module.exports = __webpack_public_path__ + "static/media/Pediatric  Child Health.a2c02cf0.png";